import * as React from "react";
import { useState } from "react";
import PrwcLanguage from "../../../ui/widgets/custom/PrwcLanguage";
import { useCoreFacade } from "../../facades/Core.facade";

const Header = () => {
  const coreFacade: any = useCoreFacade();
  const [language, setLanguage] = useState(coreFacade.getLanguage());
  const IMG = (imgName: string) => {
    return require(`./../../../../../../assets/icons/${imgName}.png`)?.default;
  };

  const onLanguageChange = (value: any) => {
    console.log("onLanguageChange --- ");
    setLanguage(value);
    // i18n.changeLanguage(value);
    coreFacade.updateLanguage(value);
  };

  return (
    <div className="flex items-center justify-between px-5 bg-gray-100 h-14">
      <div className="text-xl font-semibold text-indigo-800 ">
        {" "}
        <img
          className="h-8"
          src={IMG("brand-logo")}
          alt="Praxical Tech"
        ></img>
      </div>
      <div>
        <PrwcLanguage
          language={language}
          onLanguageChange={onLanguageChange}
        ></PrwcLanguage>
      </div>
    </div>
  );
};

export default Header;
